import { Container, BigBoldText } from "./form/sharedImports";
import { useFormManagement } from "./form/useFormManagement";
import FallForm from "./form";

const FallAnalysis = ({ handleCloseModal, title, handleFormSubmit }: any) => {
  const {
    facilityOptions,
    isFetching,
    setFieldValue,
    handleSubmit,
    values,
    isSubmitDisabled,
  } = useFormManagement({ submitFn: handleFormSubmit });

  return (
    <Container>
      <div className="mb-7">
        <button
          type="button"
          onClick={() => handleCloseModal()}
          className="cursor-pointer text-4xl font-medium"
          style={{ backgroundColor: "transparent", border: "0" }}
        >
          &times;
        </button>
        <div className="flex-1 text-center">
          <BigBoldText>{title}</BigBoldText>
        </div>
      </div>

      <FallForm
        formName="fallAnalysisForm"
        handleSubmit={handleSubmit}
        facilityOptions={facilityOptions}
        setFieldValue={setFieldValue}
        values={values}
        closeFn={handleFormSubmit}
        isSubmitDisabled={isSubmitDisabled}
        isFetching={isFetching}
        bottom={false}
      />
    </Container>
  );
};

export default FallAnalysis;
